import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import { Button, Grid, Stack } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import { focusElemnt, isEmpty, navigation1, removeDuplicatesFromArray } from '../../../../common/helper'
import { autoReceiveDataInsertUpdate } from '../../../../../store/generalSetting/GSAction'
import { connect } from 'react-redux'
import { updateAlertError } from '../../../../../store/common/common_action'
import Alert from '../../../../common/alert'
import { GetRequestCachedV3, PostRequestCachedV3 } from '../../../../common/api'
import { API_CACHE_DURATION, urls } from '../../../../common/constants'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const AutoReceiveModal = (props) => {
    const { updateModal, data, updateAlertError, autoReceiveDataInsertUpdate,
        dataValue: { editData, isEdit, mdt, headerText, daysList, hoursList, minsList, setIsSuccess, setMessage, getTableData } } = props
    const { translations, language } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const { common: { loginData } } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [showAlert, setShowAlert] = useState({
        show: false,
        message: '', 
        nextId:''
      })
    const statusList = [
        { id: 0, name: tr('gsInactive', 'Inactive') },
        { id: 1, name: tr('gsActive', 'Active') }
    ]
    const [row, setRow] = useState(null)
    const selectedStatusLabel = statusList.find((item) => item.id === (row?.IsActive ?? 1))?.name || statusList[1]?.name
    const selectedCityLabel = row?.CityID === 0
        ? cityList.find((item) => item.id === 0)?.name || row?.CityName || ''
        : row?.CityName || ''
    const [cityList, setCityList] = useState([])
    const [branchList, setBranchList] = useState([])
    const [userList, setUserList] = useState([])
    const [reset, setReset] = useState({fromBranch:false,fromUser:false})

    useEffect(() => {
        if (!isEmpty(loginData)) {
            const cityObj = {
                intCompanyID: loginData.intCompanyID,
                intBranchID: 0,
                intUserID: 0,
            }
            PostRequestCachedV3(urls.getCompCityList, cityObj, true, API_CACHE_DURATION)
                .then((res) => {
                    if (res.status === 'Success' && res?.Data?.length > 0) {
                        let cities = [{ id: 0, name: 'All' }]
                        res.Data.map(function (obj) {
                            cities.push({
                                id: obj.CityID,
                                name: obj.CityName,
                            })
                        })
                        cities = removeDuplicatesFromArray(cities, `id`)
                        cities.sort((a, b) => a.name.localeCompare(b.name))
                        setCityList(cities)
                    } else {
                        setCityList([])
                    }
                })
                .catch((err) => {
                    console.log(err)
                    setCityList([])
                })
        }
    }, [loginData])

    useEffect(() => {
        if (!isEmpty(loginData) && (row?.CityID || row?.CityID === 0)) {
            setBranchList([])
            const branchData = {
                intUserID: loginData?.intUserID,
                intCompanyID: loginData?.intCompanyID,
                intCityID: row?.CityID,
                intBookingBranchID:loginData?.intBranchID,
            }
            GetRequestCachedV3(urls.getBranchList, branchData, true, API_CACHE_DURATION)
                .then((res) => {
                    if (res.status === 'Success' && res.Data?.Table?.length > 0) {
                        let branches = res.Data.Table
                            .filter((obj) => [2, 3].includes(obj.BranchTypeID))
                            .map(function (obj) {
                                return {
                                    id: obj.BranchID,
                                    name: obj.BranchName,
                                    city: obj.CityID,
                                    companyID: obj.CompanyID
                                }
                            })
                        branches = removeDuplicatesFromArray(branches, `id`)
                        branches.sort((a, b) => a.name.localeCompare(b.name))
                        setBranchList(branches)
                    } else {
                        setBranchList([])
                    }
                })
                .catch((err) => {
                    console.log(err)
                    setBranchList([])
                })
        } else {
            setBranchList([])
        }
    }, [row?.CityID, loginData])

    useEffect(() => {
        if (row?.BranchID && !row?.CompanyID && branchList.length > 0) {
            const selectedBranch = branchList.find((branch) => Number(branch.id) === Number(row.BranchID))
            if (selectedBranch?.companyID) {
                setRow((prev) => ({ ...prev, CompanyID: selectedBranch.companyID }))
            }
        }
    }, [branchList, row?.BranchID, row?.CompanyID])

    useEffect(() => {
        const selectedBranchId = row?.BranchID
        const selectedCompanyId = row?.CompanyID
        if (!isEmpty(loginData) && selectedBranchId && selectedCompanyId) {
            setUserList([])
            const userData = {
                intUserID: 0,
                intCompanyID: selectedCompanyId,
                intIsActive: 1,
            }
            GetRequestCachedV3(urls.getOwnAndChildUsersList, userData, true, API_CACHE_DURATION)
                .then((res) => {
                    if (res.status === 'Success' && res.Data?.Table?.length > 0) {
                        let users = res.Data.Table
                            .filter((obj) => Number(obj.BranchID) === Number(selectedBranchId))
                            .map(function (obj) {
                                return {
                                    id: obj.UserID,
                                    name: obj.UserName?.trim(),
                                    branch: obj.BranchID
                                }
                            })
                        users = removeDuplicatesFromArray(users, `id`)
                        users.sort((a, b) => a.name.localeCompare(b.name))
                        setUserList(users)
                    } else {
                        setUserList([])
                    }
                })
                .catch((err) => {
                    console.log(err)
                    setUserList([])
                })
        } else {
            setUserList([])
        }
    }, [row?.BranchID, row?.CompanyID, loginData])

    useEffect(() => {
        focusElemnt('revcByCity')
    }, [])
    useEffect(() => {
        if (!isEmpty(editData)) {
            setRow(editData)
        } else {
            setRow({IsActive:1})
        }
    }, [editData])
    useEffect(() => {
        if (row?.CityID !== 0) return
        const selectedCity = cityList.find((item) => item.id === 0)
        if (selectedCity && selectedCity.name !== row.CityName) {
            setRow((prev) => ({ ...prev, CityName: selectedCity.name }))
        }
    }, [cityList, row?.CityID, row?.CityName])
    const handleCloseAlert = (nextId) => {
        setShowAlert({ show: false, message: '', nextId: "" })
        focusElemnt(nextId)
      }
    const handleSave = () => {
        if (!row.hasOwnProperty('CityID')||row?.CityID===undefined) {
        setShowAlert({ show: true, message: tr('atPleaseSelectCity', "Please Select The City"),nextId: 'revcByCity' }) 
        } else if (!row.hasOwnProperty('BranchID')||row?.BranchID===undefined||row?.BranchID==='') {
        setShowAlert({ show: true, message: tr('atPleaseSelectBranch', "Please Select The Branch"),nextId: 'recvByBranch' }) 
        } else if (!row.hasOwnProperty('UserID')||row?.UserID===undefined||row?.UserID==='') {
        setShowAlert({ show: true, message: tr('atPleaseSelectUser', "Please Select The User"),nextId: 'recvByUser' }) 
        } else if (!row.hasOwnProperty('Days')||row?.Days===undefined) {
        setShowAlert({ show: true, message: tr('atPleaseSelectDays', "Please Select The Number Of Days"),nextId: 'recvAfterDays' }) 
        } else if (!row.hasOwnProperty('Hours')||row?.Hours===undefined) {
        setShowAlert({ show: true, message: tr('atPleaseSelectHours', "Please Select The Number Of Hours"),nextId: 'recvAfterHours' }) 
        } else if (!row.hasOwnProperty('Minutes')||row?.Minutes===undefined) {
        setShowAlert({ show: true, message: tr('atPleaseSelectMinutes', "Please Select The Number Of Minutes"),nextId: 'recvAfterMins' }) 
        } else if (!row.hasOwnProperty('IsActive')||row.IsActive===undefined) {
        setShowAlert({ show: true, message: tr('atPleaseSelectNumStatus', "Please Select The Number Of Status"),nextId: 'recvStatus' }) 
        }else{
        let totalMins = row?.Days * 24 * 60 + +row?.Hours * 60 + +row?.Minutes
        let object = {
            BranchID: row?.BranchID,
            AutoReceiveUserID: row?.UserID,
            IsActive: row?.IsActive,
            ModifiedByUser: loginData?.intUserID,
            Minutes: totalMins
        }
        isEdit ? setMessage(tr('atArUpdated', 'Auto Receive\nUpdated Successfully!')) : setMessage(tr('atNewArSaved', 'New Auto Receive Config.\nSaved Successfully!'))
        autoReceiveDataInsertUpdate(object)?.then((res) => {
            if (res?.status == 'Success') {
                isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoReceivePopupModal)
                setIsSuccess(true)
                getTableData()
                focusElemnt('arNewAutoRecv')
            } else {
                isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoReceivePopupModal)
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: 'arNewAutoRecv' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    }
    return (<>
        <Modal
            headTxt={headerText}
            width={'45%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <Grid container sx={{ padding: '10px 8px 10px 8px' }} >
                <Grid item md={6}>
                    <Grid container rowSpacing={1}>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    key={`revcByCity-${language}-${row?.CityID ?? 'empty'}`}
                                    id='revcByCity'
                                    label={tr('atSelectArByCity', "Select Auto Receive By City")}
                                    width="100%"
                                    prevId='abtAddBtn'
                                    nextId='recvByBranch'
                                    defaultvalue={selectedCityLabel}
                                    value={selectedCityLabel}
                                    data={cityList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    disabled={isEdit}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, CityID: val.id, CityName: val.name, BranchID: '', BranchName: '', CompanyID: '', UserID: '', UserName: '' }))
                                        setReset((prev)=>({...prev, fromBranch:false}));
                                        setTimeout(() => {
                                            setReset((prev)=>({...prev, fromBranch:true}));
                                        }, 100);
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    key={`recvByBranch-${row?.CityID}`}
                                    id='recvByBranch'
                                    label={tr('atSelectArByBranch', "Select Auto Receive By Branch")}
                                    width="100%"
                                    prevId='revcByCity'
                                    nextId='recvByUser'
                                    defaultvalue={row?.BranchName || ''}
                                    data={branchList}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    disabled={isEdit || (!row?.CityID && row?.CityID !== 0)}
                                    onSelResetVal={true}
                                    resetFlag={reset?.fromBranch}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, BranchID: val.id, BranchName: val.name, CompanyID: val.companyID, UserID: '', UserName: '' }))
                                        setReset((prev)=>({...prev, fromUser:false}));
                                        setTimeout(() => {
                                            setReset((prev)=>({...prev, fromUser:true}));
                                        }, 100);
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    key={`recvByUser-${row?.BranchID}`}
                                    id='recvByUser'
                                    label={tr('atSelectArByUser', "Select Auto Receive By User")}
                                    width="100%"
                                    prevId='recvByBranch'
                                    nextId='recvAfterDays'
                                    defaultvalue={row?.UserName || ''}
                                    data={userList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    disabled={!row?.BranchID}
                                    onSelResetVal={true}
                                    resetFlag={reset?.fromUser}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, UserID: val.id, UserName: val.name }))
                                    }}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6}>
                    <Grid container rowSpacing={1}>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvAfterDays'
                                    label={tr('atSelectArAfterDays', "Select Auto Receive After Days")}
                                    width="100%"
                                    prevId='recvByUser'
                                    nextId='recvAfterHours'
                                    defaultvalue={row?.Days === 1 ? `${row?.Days} Day` : row?.Days >= 0 ? `${row?.Days} Days` : '' || ''}
                                    calendarIcon={true}
                                    data={daysList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, Days: val?.id }))
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvAfterHours'
                                    label={tr('atSelectArAfterHours', "Select Auto Receive After Hours")}
                                    width="100%"
                                    prevId='recvAfterDays'
                                    nextId='recvAfterMins'
                                    defaultvalue={row?.Hours === 1 ? `${row?.Hours} Hour` : row?.Hours >= 0 ? `${row?.Hours} Hours` : ''}
                                    watchIcon={true}
                                    data={hoursList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, Hours: val?.id }))
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvAfterMins'
                                    label={tr('atSelectArAfterMinutes', "Select Auto Receive After Minutes")}
                                    width="100%"
                                    prevId='recvAfterHours'
                                    nextId='recvStatus'
                                    defaultvalue={row?.Minutes === 1 ? `${row?.Minutes} Min.` : row?.Minutes >= 0 ? `${row?.Minutes} Mins.` : ''}
                                    watchIcon={true}
                                    data={minsList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, Minutes: val?.id }))
                                    }}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container sx={{ padding: '10px 8px 10px 8px', borderTop: '1px solid #ddd' }} >
                <Grid item md={6}>
                    <Grid container rowSpacing={1}>

                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    key={`recvStatus-${language}-${selectedStatusLabel}`}
                                    id='recvStatus'
                                    label={tr('gsStatus', "Status")}
                                    width="100%"
                                    prevId='recvAfterMins'
                                    nextId='abtCancelBtn'
                                    data={statusList || []}
                                    defaultvalue={selectedStatusLabel}
                                    searchPlaceholder={tr('atSearchStatus', `Search Status`)}
                                    dataKey={`name`}
                                    idKey={`id`}
                                    isError={row?.IsActive == 0}
                                    isSuccess={row?.IsActive == 1 }
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, IsActive: val.id }))
                                    }
                                       
                                    }
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item md={6}>
                    <Grid container rowSpacing={1}>

                        <Grid item md={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <Item>
                                <Button
                                    id="abtCancelBtn"
                                    style={{ margin: '0', height: "40px" }}
                                    className="btn cancel-btn"
                                    variant="outlined"
                                    color="error"
                                    onClick={() => {
                                        isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoReceivePopupModal)
                                    }}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'abtAddBtn', 'recvStatus');
                                    }}
                                >
                                    {tr('cancel', 'Cancel')}
                                </Button></Item>
                            <Item>
                                <Button
                                    id="abtAddBtn"
                                    style={{ margin: '0', height: "40px" }}
                                    className="btn add-btn"
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                        handleSave()
                                    }}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'revcByCity', 'abtCancelBtn');
                                    }}
                                >
                                    {isEdit ? tr('atUpdateTitle', 'Update') : tr('atSaveTitle', 'Save')}
                                </Button></Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Modal>
    {showAlert.show && <Alert msg={showAlert.message} error={true} close={()=>handleCloseAlert(showAlert.nextId)} />}
</>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    autoReceiveDataInsertUpdate, updateAlertError
}
export default connect(mapStateToProps, mapDispatchToProps)(AutoReceiveModal)
